export default {
    name: "FooterAnth",
    data() {
      return {
        redesSociales: [
          {
            nombre: "Facebook",
            url: "https://www.facebook.com/clickherepcecuador",
            icono: "/IconosRS/facebook.png",
          },
          {
            nombre: "Instagram",
            url: "https://www.instagram.com/clickhere.pc",
             icono: "/IconosRS/instagram.png",
          },
          {
            nombre: "TikTok",
            url: "https://www.tiktok.com/@chpctecnologia",
            icono: "/IconosRS/tiktok.png",
          },
          {
            nombre: "WhatsApp",
            url: "https://wa.me/593995924867",
            icono: "/IconosRS/whatsapp.png",
          },
        ],
      };
    },
  };